<div class="table-responsive">
  <table class="table generic-table styled-booking-table ">
    <thead>
      <tr>
        <th *ngFor="let col of columns">
          {{ col.header }}
        </th>
        <th *ngIf="actions?.length"></th>
      </tr>
    </thead>
<tbody *ngIf="!loading">
  <tr *ngFor="let row of data">
    <ng-container [ngSwitch]="columns[0]?.field">

      <!-- Hotels, Flights, etc. with EMPLOYEE -->
      <ng-container *ngSwitchCase="'employee'">
        <td class="employee-cell">
          <div class="d-flex align-items-center">
            <img [src]="'https://i.pravatar.cc/40?u=' + row.employee" class="employee-photo me-3" />
            <div>
              <div class="fw-bold">
                {{ row.employee }}
              </div>
              <a class="employee-email" [href]="'mailto:' + row.email || 'jamemarker@company.co'">
                {{ row.email || 'jamemarker@company.co' }}</a>
            </div>
          </div>
        </td>
        <td *ngFor="let col of columns.slice(1, columns.length - 1)">
          <ng-container *ngIf="col.field === 'location' || col.field === 'route'">
            <div>
              {{ row[col.field]?.split(',')[0] }}
            </div>
            <div class="fw-bold">
              {{ row[col.field]?.split(',')[1] }}
            </div>
          </ng-container>
          <ng-container *ngIf="col.field === 'dates'">
            <div>
              {{ row[col.field]?.split('-')[0] }}
            </div>
            <div>To</div>
            <div>
              {{ row[col.field]?.split('-')[1] }}
            </div>
          </ng-container>
          <ng-container *ngIf="col.field !== 'location' && col.field !== 'dates' && col.field !== 'route'">
            {{ row[col.field] }}
          </ng-container>
        </td>
        <td><span class="status-badge">
            {{ row.status }}</span></td>
      </ng-container>

      <!-- All other categories (default) -->
      <ng-container *ngSwitchDefault>
        <td *ngFor="let col of columns">
          {{ row[col.field] }}
        </td>
      </ng-container>

    </ng-container>

    <!-- Actions Dropdown -->
    <td *ngIf="actions?.length">
      <div class="dropdown mt-2 dropstart">
        <a class="text-dark" href="#" data-bs-toggle="dropdown" aria-expanded="false">
          <fa-icon [icon]="actions[0].icon"></fa-icon>
        </a>
        <ul class="dropdown-menu">
          <li *ngFor="let act of actions">
            <a class="dropdown-item" href="#" (click)="onAction(act, row)">
              <fa-icon class="me-2" [icon]="act.view"></fa-icon>
              View Booking Details
            </a>
          </li>
        </ul>
      </div>
    </td>
  </tr>
</tbody>

  </table>

   <div class="row" *ngIf="!data?.length && !loading">
                    <div class="col-12 mt-5 text-center">
                      <h5 class="mb-5">
                        <fa-icon  size="5x" [icon]="icons.homeUser"></fa-icon>
                      </h5>
                      <h5 class="text-f20-bold text-center">Sorry, You don’t have any <br> request yet!</h5>
                      <div class="my-4 d-flex justify-content-center align-items-center">
                            <span class="line w-25">&nbsp;</span>
                        </div>
                       
                        <div class="my-4">
                            <app-button routerLink="/assisted-booking"  [class]="'btn map-button-x hide-mobile-x'" 
                            warning> Send a request </app-button>
                        </div>
                    </div>
                  </div>

                  <div class="row" *ngIf="!data || loading">
                <div class="col-12 text-center">
                    <app-loader></app-loader>
                </div>
            </div>
</div>